/**
 * UI adapter: bridges React tick scheduler to UpdateOrgSimulationUseCase (UC-33)
 * Enable via architectureFeatures.useOrgSimulationUseCase
 */
import { useCallback } from 'react';
import { updateOrgSimulationUseCase } from '../../../infrastructure/di/container';
import { architectureFeatures } from '../../../infrastructure/config/features';
import type { UpdateOrgSimulationOutput } from '../../../application/use-cases/UpdateOrgSimulationUseCase';

/** Run org simulation update through clean architecture use case */
export function executeOrgSimulationUpdate(tickNumber: number): UpdateOrgSimulationOutput {
  if (!architectureFeatures.useOrgSimulationUseCase) {
    throw new Error('useOrgSimulationUseCase feature flag is disabled');
  }

  return updateOrgSimulationUseCase.execute(tickNumber);
}

/**
 * Hook helper for App.tsx integration.
 * Returns a stable callback that runs UC-33 when feature flag is on.
 */
export function useOrgSimulationRunner() {
  return useCallback((tickNumber: number): UpdateOrgSimulationOutput | null => {
    if (!architectureFeatures.useOrgSimulationUseCase) {
      return null;
    }
    return executeOrgSimulationUpdate(tickNumber);
  }, []);
}